/* INDEX FILE

This file, from a module perspective, behaves as the duck file form the original proposal.
It exports as default the reducer function of the duck.
It exports as named export the selectors and the operations.
Optionally it exports the actions and types if they are needed in other ducks.

*/

import reducer from "./reducers";

// import * as merchantSelectors from "./selectors";
import * as userOperations from "./operations";
import * as userActions from "./actions";
import * as userTypes from "./types";

export {
    userOperations,
    userActions,
    userTypes
};

export default reducer;


// WEBPACK FOOTER //
// ./src/redux/user/index.js